/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { fetchGraphQl } from '../fetch-graphql';
import { handleNetworkError } from '@/auth/lib/network-error';
import { RESEND_CONFIRMATION_EMAIL } from './graphql/resendConfirmationEmail.graphql';
import { resendConfirmationEmailResponse } from '@/auth/types';

export const resendConfirmationEmail = async (
  customerEmail: string
): Promise<resendConfirmationEmailResponse> => {
  return await fetchGraphQl(RESEND_CONFIRMATION_EMAIL, {
    method: 'POST',
    variables: {
      email: customerEmail,
    },
  }).catch(handleNetworkError);
};
